import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-calendar-plus-02',
  imports: [],
  templateUrl: './calendar-plus-02.html',
  styleUrl: './calendar-plus-02.scss',
})
export class CalendarPlus02 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
